import { exec } from "child_process"
import path from "path"

const DEFAULT_SECURITY_CHECK_INTERVAL = 10

function getDateFileName () {
    const d = new Date()
    return `${d.getDate()}-${d.getMonth()}-${d.getFullYear()}`
}

const security = {
    nextSecurityCheck: 0,
    isChecking: false,
    nspCheck (app) {
        exec(
            `node ` +
            path.resolve(
                app.paths.furtherRef,
                'node_modules',
                'nsp',
                'bin',
                'nsp'
            ) +
            ' check --reporter table' +
            ' > ' +
            path.resolve(
                app.paths.project,
                '.further',
                'reports',
                'nsp'
            ),
            result => {
            }
        )
    },
    async check (app) {
        if (this.isChecking) {
            return
        }
        this.isChecking = true
        if (!app.opts.security) {
            app.opts.security = {
                interval : DEFAULT_SECURITY_CHECK_INTERVAL
            }
        }
        let interval = app.opts.security.interval * 60 * 1000
        let now = (new Date).getTime()
        if (!this.nextSecurityCheck || this.nextSecurityCheck < now) {
            this.nextSecurityCheck = now + interval
            await security.nspCheck(app)
        }
        this.isChecking = false
    }
}

export default security



// WEBPACK FOOTER //
// ./src/security.js